<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" sm="8" md="6">
        <v-card class="rounded-24 pa-4 vs-card-light" elevation="4">
          <v-card-text>
            <v-row align="center">
              <v-col cols="12" class="text-center pt-4">
                <v-avatar size="90" color="rgba(49, 95, 216, 0.12)" class="mb-3">
                  <v-icon size="60" color="#315fd8">mdi-account</v-icon>
                </v-avatar>
                <div class="vs-eyebrow">PERFIL DO ALUNO</div>
                <v-card-title class="text-center font-weight-bold pt-1" style="font-family: 'Roboto Condensed', sans-serif; font-size: 1.5rem; color: #030a1a;">
                  Dados da Conta
                </v-card-title>
              </v-col>
              <v-col cols="12">
                <v-row>
                  <v-col cols="6">
                    <v-text-field v-model="firstName" label="Nome" prepend-icon="mdi-account" variant="outlined" density="comfortable"></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field v-model="lastName" label="Sobrenome" variant="outlined" density="comfortable"></v-text-field>
                  </v-col>
                </v-row>
                <v-text-field v-model="userEmail" label="Email" prepend-icon="mdi-email" readonly class="disabled" variant="outlined" density="comfortable"></v-text-field>
                <v-text-field v-model="userPhone" label="Telefone" prepend-icon="mdi-phone" variant="outlined" density="comfortable"></v-text-field>
                <v-row>
                  <v-col cols="6">
                    <v-text-field v-model="userAge" label="Idade" type="number" prepend-icon="mdi-human-child" variant="outlined" density="comfortable"></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-select v-model="userGender" :items="genderOptions" label="Gênero" variant="outlined" density="comfortable"></v-select>
                  </v-col>
                </v-row>
                <!-- Adicione outros campos conforme necessário -->
              </v-col>
            </v-row>
            <v-divider class="my-4"></v-divider>
            <div class="text-center" style="color: #768199; font-size: 12px;">
              <v-icon size="14" class="mr-1">mdi-shield-check-outline</v-icon>
              Os dados inseridos estão protegidos conforme as normas da LGPD.
            </div>
          </v-card-text>
          <v-card-actions class="px-4 pb-4">
            <v-spacer></v-spacer>
            <v-btn variant="elevated" class="vs-btn-primary px-8" style="height: 44px; color: white !important;" @click="saveChanges">
              Salvar Alterações
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { ref } from 'vue';

export default {
  data() {
    return {
      firstName: '',
      lastName: '',
      userEmail: '',
      userPhone: '',
      userAge: '',
      userGender: '',
      genderOptions: ['Masculino', 'Feminino', 'Outro']
    };
  },
  computed: {
    userData() {
      return [
        { key: 'firstName', value: this.firstName },
        { key: 'lastName', value: this.lastName },
        { key: 'userEmail', value: this.userEmail },
        { key: 'userPhone', value: this.userPhone },
        { key: 'userAge', value: this.userAge },
        { key: 'userGender', value: this.userGender }
      ];
    }
  },
  created() {
    // Inicialize os dados do usuário quando o componente for criado
    const userData = this.$store.getters.userName;
    if (userData && userData.length > 0) {
      const user = userData[0];
      this.firstName = user.firstName || '';
      this.lastName = user.lastName || '';
      this.userEmail = user.userEmail || '';
      this.userPhone = user.userPhone || '';
      this.userAge = user.userAge || '';
      this.userGender = user.userGender || '';
    }
  },
  
  methods: {
    saveChanges() {
      const userPayload = {
        name: this.firstName,
        lastName: this.lastName,
        email: this.userEmail,
        phone: this.userPhone,
        age: this.userAge,
        gender: this.userGender
      };
      console.log(userPayload); 
      this.$store.dispatch('saveProfile', userPayload)
        .then(() => {
          console.log("Submission successful. Reloading...");
          // Reload the window after successful submission
          setTimeout(() => {
           // window.location.reload();
            this.$router.push('/webapp/profile');
          }, 1000); // 2000 milliseconds = 2 seconds
        })
      
      // Exemplo: Exibindo os dados do usuário no console
      // Aqui você pode enviar os dados do usuário para o servidor
      // Ou realizar qualquer ação necessária com os dados do usuário
    }
  },
  
};
</script>

<style scoped>
.v-card {
  max-width: 600px;
  margin: 0 auto;
}
</style>
